export default __webpack_public_path__ + "static/media/children2.8485437c.jpg";